// config.js

const bizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const myBizIcon = 'https://mybizsolutions.us/static/media/icon-app-logo.83ff8bf39a11df9fb7ac.jpg';
const imageOne = "https://media.istockphoto.com/id/1137901407/photo/excavator-is-loading-a-truck-with-ground-on-building-site.jpg?s=612x612&w=0&k=20&c=IG4U6Da7h0ESrrkg7CtIPFWQxE7kHK6iyjpT98z6AgQ=";
const imageTwo = "https://media.istockphoto.com/id/172647263/photo/bull-dozer.jpg?s=612x612&w=0&k=20&c=p7J9FoHmRqkpHvG0brbPaBZ_mRZOU0VSNlB27z__wDQ=";
const imageThree = "https://media.istockphoto.com/id/1163671259/photo/construction-worker-on-a-heavy-site-doing-hard-work.jpg?s=612x612&w=0&k=20&c=nKoslUkTi4dA8T-XVDvYWmA4mg5iajuqB1tHcIkt5qg=";
const imageFour = "https://media.istockphoto.com/id/2169660961/photo/road-building-with-backhoe-works-excavator-with-heavy-back-hoe-working-on-construction-site.jpg?s=612x612&w=0&k=20&c=RdeYVuICiIU-buuVgOsN4K_eNE-NJZoeFxypQWKpidA=";
const imageFive = "https://media.istockphoto.com/id/530746094/photo/construction-worker.jpg?s=612x612&w=0&k=20&c=qMfHBHTKVwbX10VuAlZIDukuB7w9bX5BMSJWbgvVvQ4=";

const redirectLink = "https://mybizsolutions.us/";

export const siteConfig = {
  title: "JPT Excavations",
  metaDescription: "JPT Excavations",
  theme: {
    primaryColor: "red-600",
    secondaryColor: "gray-900",
    accentColor: "text-red-600"
  },
  logo: {
    src: bizIcon,
    alt: "JPT Excavations Icon",
  },
  navigation: [
    { name: "Services", sectionId: "services" },
    { name: "About", sectionId: "about" },
    { name: "Location", sectionId: "location" },
  ],
  businessDetails: {
    name: "JPT Excavations",
    headline: "Your Trusted Partner for Professional Excavation Services in New Orleans, LA",
    address: "4750 Hauck Dr, New Orleans, LA 70127",
    description: `
        Welcome to JPT Excavations, your premier choice for reliable excavation services in New Orleans, LA. With expertise in site preparation, grading, trenching, and more, we are dedicated to delivering precision and quality for every project. Whether you're working on residential, commercial, or industrial sites, our team ensures your groundwork is handled with efficiency and professionalism. Trust JPT Excavations to lay the foundation for your success.
    `,
  },
  images: {
    business: {
      src: imageOne,
      alt: "Your Trusted Partner for Professional Excavation Services in New Orleans, LA",
      width: 2432,
      height: 1442
    }
  },
  features: [
    {
        description: 
          "Comprehensive Excavation Services: From land clearing to site preparation, we offer a full range of excavation solutions tailored to your project needs.",
    },
    {
        description: 
          "Reliable Equipment & Expertise: With state-of-the-art machinery and a skilled team, we ensure precision, safety, and efficiency for every excavation task.",
    },
    {
        description: 
          "Serving New Orleans and Beyond: Proudly providing exceptional excavation services to New Orleans, LA, and neighboring communities, ensuring every project starts on solid ground.",
    },
  ],
  services: {
    sectionTitle: "Our Excavation Services",
    description: 
      "At JPT Excavations, we specialize in a wide range of excavation services designed to meet your unique project requirements. From residential site preparation to large-scale commercial trenching, our team delivers quality results you can depend on.",
    callouts: [
        {
          name: 'Site Preparation',
          description: 
            "Ensure your construction project starts right with our professional site preparation services. We handle grading, leveling, and land clearing with precision.",
          imageSrc: imageTwo,
          imageAlt: 'Excavators preparing a construction site with precision.',
        },
        {
          name: 'Trenching & Utility Work',
          description: 
            "Our trenching services provide a solid foundation for underground utilities, ensuring durability and safety for your infrastructure.",
          imageSrc: imageThree,
          imageAlt: 'Team performing trenching work for utility installation.',
        },
        {
          name: 'Demolition & Land Clearing',
          description: 
            "Clear the way for new projects with our efficient demolition and land clearing services. We remove obstacles and prepare sites for seamless construction.",
          imageSrc: imageFour,
          imageAlt: 'Land clearing services preparing a site for new construction.',
        },
    ],
    otherServices: [
        "Grading",
        "Foundation Excavation",
        "Storm Drainage Solutions",
        "Heavy Equipment Rentals",
    ],
  },
  about: {
    sectionTitle: "About Us",
    description:   
      "JPT Excavations is dedicated to providing top-tier excavation services to New Orleans, LA, and surrounding areas. With a reputation for excellence and reliability, we specialize in site preparation, trenching, grading, and more. Our skilled team is committed to delivering exceptional results, using advanced equipment and industry-best practices to meet the needs of residential, commercial, and industrial projects.\n\nWhether you're breaking ground for a new home, installing utilities, or clearing land for large-scale development, JPT Excavations ensures every project is executed with precision, safety, and efficiency. Trust us to be your excavation experts and lay the groundwork for your success.",
    image: {
      src: imageFive,
      alt: "JPT Excavations team delivering professional excavation services in New Orleans, LA.",
      width: 1200,
      height: 800,
    },
  },
  location: {
    sectionTitle: "Our Location",
    destinationAddress: "4750 Hauck Dr, New Orleans, LA 70127",
    googleMapsEmbedUrl: 
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3448.123456789012!2d-89.956796284895!3d29.99508148185678!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x889f6dbeb32acb01%3A0xabcdef123456789!2s4750%20Hauck%20Dr%2C%20New%20Orleans%2C%20LA%2070127%2C%20USA!5e0!3m2!1sen!2sus!4v1710407450828!5m2!1sen!2sus",
    subCategories: [
      { 
        name: 'Apple Maps', 
        url: 'https://maps.apple.com/?address=4750+Hauck+Dr,+New+Orleans,+LA+70127,+USA',
      },
      { 
        name: 'Bing Maps', 
        url: 'https://www.bing.com/maps?q=4750+Hauck+Dr,+New+Orleans,+LA+70127&FORM=HDRSC6',
      },
      { 
        name: 'Google Earth', 
        url: 'https://earth.google.com/web/search/4750+Hauck+Dr,+New+Orleans,+LA+70127,+USA/@29.995081,-89.956796,15a,814.57589625d,35y,0h,0t,0r',
      },
      { 
        name: 'Google Maps', 
        url: 'https://www.google.com/maps/place/4750+Hauck+Dr,+New+Orleans,+LA+70127,+USA/@29.995081,-89.956796,15z',
      },
    ],
  },
  contact: {
    sectionTitle: "Get in Touch with JPT Excavations",
    description: 
      "Ready to start your next excavation project? JPT Excavations is here to provide top-quality services tailored to your needs. Contact us today for a free consultation or estimate. Let’s lay the foundation for your success!",
    socialLinks: {
      facebook: redirectLink,     
      instagram: redirectLink,     
      twitter: redirectLink,     
      linkedin: redirectLink,     
      youtube: redirectLink,     
    },
    contactNumbers: [
      "Mobile: (504)-339-7112",
    ],
    logo: bizIcon,
    emailRecipient: "jpt.excavation@gmail.com"
  },
  footer: {
    bizSolutionsLogo: myBizIcon
  }
};


